module.exports = __webpack_public_path__ + "static/img/_logo.81e8eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_logo.png
// module id = naGJ
// module chunks = 1